<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <span class="cs-title">课件资料</span>
              <el-row class="grid-content">
                <el-row>
                  <el-col :span="24">
                    <breadcrumbNavigationBar :data="homeworkNavigationBarData"></breadcrumbNavigationBar>
                  </el-col>
                </el-row>
                <el-row>
                  <pagination
                    v-loading="loading"
                    :data="coursewarekList"
                    :option="paginationOption"
                    @customEvent="customEventHandler"
                  ></pagination>
                </el-row>
              </el-row>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
/deep/ body .el-table .el-table-header th {
  height: 30px;
  padding: 5px 0px;
  color: #909399 !important;
  background-color: #fff !important;
}

.cs-contentContainer {
  .grid-content {
    margin-top: 15px;
    /deep/ .el-table .el-table-header th {
      height: 30px;
      padding: 5px 0px;
      color: #909399 !important;
      background-color: #fff !important;
    }
  }
}
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import breadcrumbNavigationBar from "../../components/common/breadcrumbNavigationBar";
import { getCourseWeeklyList } from "../../service/courseware.service";
import { getStore, setStore } from "../../config/mUtils";
import global_ from "../../core/global";

export default {
  data() {
    return {
      loading: false,
      paginationOption: {},
      editData: {},
      dialogEditorVisible: false,
      courseType: 1,
      courseId: 0,
      campusId: 0,
      courseName: "",
      courseActivations: [],
      coursewarekList: [],
      homeworkNavigationBarData: {},
    };
  },
  components: {
    navigator,
    pagination,
    breadcrumbNavigationBar,
  },
  computed: {},
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      hasAddButton: false,
      addButtonText: "",
      hasSearch: false,
      showAcitveColor: true,
      hideDisableRow: true,
      isStudent: this.USERMANAGER.isStudent,
      isNotStudent: !this.USERMANAGER.isStudent,
    };

    this.courseId = Number(this.$route.query.courseId);
    this.campusId = Number(this.$route.query.campusId);
    this.courseName = this.$route.query.courseName;
    this.courseType = Number(this.$route.query.courseType);
    this.loadData();
  },
  methods: {
    loadData() {
      
      if (!this.courseId){
        this.$message.error("课程错误");
      }
      this.loading = true;
      getCourseWeeklyList(this.courseId, this.campusId)
        .then((result) => {
          if (!!result && result.success) {
            this.coursewarekList = result.data;
          }else if (result.message){
            this.$message.error(result.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      this.buildNavigations();
    },
    buildNavigations() {
      this.homeworkNavigationBarData = {
        name: "",
        navList: [],
        currentName: this.courseName,
      };
      let link = "/coursewareManagement?courseType=" + this.courseType;
      if (this.courseType == 1) {
        this.homeworkNavigationBarData.navList.push({
          link: link,
          name: "大学补习",
        });
      } else if (this.courseType == 2) {
        this.homeworkNavigationBarData.navList.push({
          link: link,
          name: "应试英语",
        });
      } else {
        this.homeworkNavigationBarData.navList.push({
          link: link,
          name: "职业培训",
        });
      }
    },
    nav(data) {
      this.$router.push({
        path: "/coursewareFiles",
        query: {
          campusId: data.CampusId,
          courseId: data.CourseId,
          courseName: this.courseName,
          courseWeekName: data.CourseName,
          courseType: this.courseType,
          week: data.Week,
        },
      });
    },
    customEventHandler(data) {
      if (data.action == "nav") {
        this.nav(data.data);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/courseware/coursewareWeekly.vue